import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { Incident } from '../models/incident';

@Injectable({
  providedIn: 'root'
})
export class IncidentDataService {

  constructor(private http: HttpClient) { }


  create = (issueType: string, incident: Incident): Promise<any> => {
    const params = new HttpParams()
    .set('issueType', issueType);
    return this.http.post<Incident>(`${environment.api.baseUrl}/${environment.api.endpoints.incident.incidentList}/raiserfincident`, incident , {params}).toPromise();
  }

  getRfAttributes = (projectId: number, trainName: string , projectName: string) => {
    const params = new HttpParams()
        .set('projectId', projectId.toString())
        .set('trainName', trainName)
        .set('projectName', projectName);
    return this.http.get<string>(`${environment.api.baseUrl}/${environment.api.endpoints.incident.incidentList}/getrfassets`, {params}).toPromise();
  }

}
